export const API_URL = 'console-api-service/api/v1'
export const API_REFERRAL_URL = 'referral-backend/api/v1'
//export const SERVER = process.env.NODE_ENV === 'development' ? '' : 'https://admin.id-pay.ru/'
//export const SERVER = process.env.NODE_ENV === 'development' ? '/' : 'https://test.id-pay.ru/'
export const SERVER = '/'
export const SERVER_KEYCLOAK = '/'
